module.exports = __webpack_public_path__ + "static/media/itovi_dna_bundle.a423a878.png";